export default "__VITE_ASSET__21230735__"